import Slider from '../modules/slider';

/* products sliders */
const productsSlider = new Slider('[data-ui-el="product-slider"]', {
    loop: true,
    loopPreventsSlide: true,
    slidesPerView: 3,
    watchSlidesProgress: true,
    watchVisibleSlides: true,
    preloadImages: true,
    slidesOffsetBefore: 1,
    centerInsufficientSlides: true,
    freeMode: true,

    breakpoints: {
        360: {
            slidesPerView: 1.7,
            spaceBetween: 16,
        },
        480: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        768: {
            slidesPerView: 3,
            spaceBetween: 24,
        },
    },

    navigation: {
        nextEl: '[data-ui-el="btn-next"]',
        prevEl: '[data-ui-el="btn-prev"]',
    },
}, true);
